/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CategoryEdit_category$ref: FragmentReference;
declare export opaque type CategoryEdit_category$fragmentType: CategoryEdit_category$ref;
export type CategoryEdit_category = {|
  +id: string,
  +name: string,
  +$refType: CategoryEdit_category$ref,
|};
export type CategoryEdit_category$data = CategoryEdit_category;
export type CategoryEdit_category$key = {
  +$data?: CategoryEdit_category$data,
  +$fragmentRefs: CategoryEdit_category$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryEdit_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Category"
};
// prettier-ignore
(node/*: any*/).hash = 'c0b5badbc5ce25d90a5e137f21d26319';

module.exports = node;
